<template>
  <div class="editWatermark" v-if="media">
    <!-- 水印编辑 -->
    <el-dialog
      title="水印编辑"
      align="center"
      :visible.sync="showEditWatermark"
      :close-on-click-modal="false"
      width="830px"
      @close="handleClose"
    >
      <div class="editWatermarkBox">
        <div class="coverArea">
          <div
            class="coverBox"
            id="coverBox"
            @mousedown="startDrag"
            @mouseup="stopDrag"
          >
            <el-image
              :src="checkUrl(media.cover) + media.cover"
              class="cover"
              draggable="false"
            ></el-image>
            <div
              class="watermarkLogo"
              id="watermarkLogo"
              :style="{
                left: watermarkPosition.x + 'px',
                top: watermarkPosition.y + 'px',
                opacity: opacity,
              }"
              @mousedown.stop="beginDrag"
            >
              <el-image
                :style="{
                  width: watermarkSize.width + 'px',
                  height: watermarkSize.height + 'px',
                }"
                :src="checkUrl(logoPath) + logoPath"
                draggable="false"
              >
              </el-image>
            </div>
          </div>
        </div>
        <div class="optBox">
          <div class="labelBox">
            <div class="label">
              <span>水印宽度：</span
              ><el-input v-model="watermarkSize.width"></el-input>
            </div>
            <div class="label">
              <span>水印高度：</span
              ><el-input v-model="watermarkSize.height"></el-input>
            </div>
          </div>
          <div class="labelBox">
            <div class="label">
              <span>水印X轴：</span
              ><el-input v-model="watermarkPosition.x"></el-input>
            </div>
            <div class="label">
              <span>水印Y轴：</span
              ><el-input v-model="watermarkPosition.y"></el-input>
            </div>
          </div>
          <div class="labelBox">
            <div class="label">水印透明度:</div>
            <el-input-number
              v-model="opacity"
              controls-position="right"
              :step="0.1"
              :min="0"
              :max="1"
            ></el-input-number>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          @click="confirm"
          type="primary"
          size="small"
          :loading="loading"
          >{{ buttonText }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import { toPng } from "html-to-image";
import api from "@/api";

export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl2,
      newImgUrl: baseConfig.newImgUrl2,
      showEditWatermark: false,
      media: null,
      opacity: 1,
      watermarkPosition: {
        x: 50,
        y: 50,
      },
      isDragging: false,
      offset: {
        x: 0,
        y: 0,
      },
      loading: false,
      logoPath: "",
      watermarkSize: {
        height: 60,
        width: 60,
      },
      buttonText: "确 认",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取水印
    getList() {
      let req = {
        vcode: "videoMarkAppIcon",
      };
      api
        .getSysconfVcode(req)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.logoPath = res.data.value;
          }
        })
        .catch(() => {
          this.$message.error("水印获取失败");
        });
    },
    openEditWatermark(row) {
      this.media = row;
      this.showEditWatermark = true;
    },
    startDrag() {
      if (this.isDragging) {
        this.isDragging = false;
      }
    },
    stopDrag() {
      if (this.isDragging) {
        this.isDragging = false;
      }
    },
    beginDrag(event) {
      this.isDragging = true;
      this.offset.x = event.clientX - this.watermarkPosition.x;
      this.offset.y = event.clientY - this.watermarkPosition.y;
      document.addEventListener("mousemove", this.dragWatermark);
      document.addEventListener("mouseup", this.stopDragging);
    },
    dragWatermark(event) {
      if (!this.isDragging) return;
      let x = event.clientX - this.offset.x;
      let y = event.clientY - this.offset.y;
      const coverBox = document.getElementById("coverBox");
      const watermarkLogo = document.getElementById("watermarkLogo");
      if (x <= 0) {
        x = 0;
      }
      if (x >= coverBox.offsetWidth) {
        x = coverBox.offsetWidth - watermarkLogo.offsetWidth;
      }
      if (y <= 0) {
        y = 0;
      }
      if (y >= coverBox.offsetHeight) {
        y = coverBox.offsetHeight - watermarkLogo.offsetHeight;
      }
      this.watermarkPosition.x = x;
      this.watermarkPosition.y = y;
    },
    stopDragging() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.dragWatermark);
      document.removeEventListener("mouseup", this.stopDragging);
    },
    // 提交图片
    async confirm() {
      this.loading = true;
      this.buttonText = "生成中...";
      // 生成带水印的图片并上传的逻辑
      toPng(document.getElementById("coverBox"), { cacheBust: true })
        .then((dataUrl) => {
          this.sendImageToServer(dataUrl);
        })
        .catch((error) => {
          this.loading = false;
          this.buttonText = "确 认";
          console.error("Oops, something went wrong!", error);
        });
    },
    async sendImageToServer(dataURL) {
      const formData = new FormData();
      const blob = this.base64ToBlob(dataURL);
      formData.append("upload", blob, "image.jpeg");
      api.uploadImg(formData).then((res) => {
        if (res.code === 200) {
          this.media.cover = res.data.coverImg;
          this.editVideo(this.media);
        } else {
          this.$message({
            type: "error",
            message: "上传失败!",
          });
          this.loading = false;
          this.buttonText = "确 认";
          this.media.cover = "";
        }
      });
    },
    base64ToBlob(base64) {
      const byteString = atob(base64.split(",")[1]); // 解码 Base64
      const mimeString = base64
        .split(",")[0]
        .split(":")[1]
        .split(";")[0]; // 获取 MIME 类型
      const ab = new Uint8Array(byteString.length); // 创建一个 Uint8Array
      for (let i = 0; i < byteString.length; i++) {
        ab[i] = byteString.charCodeAt(i); // 将每个字符转换为字节
      }
      return new Blob([ab], { type: mimeString }); // 创建 Blob
    },
    // 编辑图片
    editVideo() {
      const req = {
        id: this.media.id,
        cover: this.media.cover,
        hasWatermark: true,
      };
      api
        .editVideoInfo(req)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerEditList");
          } else {
            this.$message.error("编辑失败！");
          }
          this.loading = false;
          this.buttonText = "确 认";
          this.handleClose();
        })
        .catch(() => {
          this.loading = false;
          this.buttonText = "确 认";
          this.handleClose();
        });
    },
    handleClose() {
      this.showEditWatermark = false;
      this.loading = false;
      this.buttonText = "确 认";
      this.opacity = 1;
      this.watermarkPosition = {
        x: 50,
        y: 50,
      };
      this.offset = {
        x: 0,
        y: 0,
      };
      this.watermarkSize = {
        height: 60,
        width: 60,
      };
    },
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl;
        } else {
          return this.imgUrl;
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.editWatermark {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome */
  .editWatermarkBox {
    display: flex;
    .coverArea {
      .coverBox {
        width: 384px;
        position: relative;
        .cover {
          width: 100%;
          display: block !important;
        }
        .watermarkLogo {
          position: absolute;
          cursor: pointer;
        }
      }
    }
    .optBox {
      flex: 1;
      margin-left: 30px;
      .labelBox {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .label {
          font-size: 14px;
          margin-right: 10px;
          display: flex;
          align-items: center;
          span {
            margin-right: 10px;
            width: 140px;
          }
        }
      }
    }
  }
}
</style>
